<template>
  <!--Cab Services Section Start-->
  <section class="cab-services" v-if="services">
    <jumbotron :h1="'Professional Services'" v-if="this.$route.fullPath!='/'"/>
    <div class="container">
      <div class="row">
        <!--Cab Services Heading Start-->
        <div class="tj-heading-style">
          <h3>Our Services</h3>
          <p>{{serviceDescription}}</p>
        </div>
        <!--Cab Services Heading End-->
        <!--Cab Services Outer Start-->
        <div class="col-md-4 col-sm-4" v-for="(service,key) in services" :key="key">
          <div class="cab-service-box" style="    height: 420px;">
            <!--Cab Services Thumb Start-->
            <figure class="service-thumb">
              <img :src="service.imageUrl" alt />
            </figure>
            <!--Cab Services Thumb End-->
            <!--Cab Services Info Start-->
            <div class="service-desc">
              <h4>{{service.title}}</h4>
              <p>{{service.description}}</p>
            </div>
            <!--Cab Services Info End-->
          </div>
        </div>
        <!--Cab Services Outer End-->
      </div>
    </div>
  </section>
  <!--Cab Services Section End-->
</template>
<script>
import firebase from "firebase";
import  jumbotron  from "./jumbotron";
export default {
  props: {
    data: Array,
    sd: String
  },
  components:{jumbotron},
  data() {
    return {
      services: false,
      serviceDescription: ""
    };
  },
  methods: {
    getServices() {
      if (this.data) {
        this.services = this.data;
      } else {
        let that = this;
        var ref = firebase.database().ref("/services");
        ref.on(
          "value",
          function(snapshot) {
            that.services = snapshot.val();
            console.log(that.services);
          },
          function(error) {
            console.log("Error: " + error.code);
          }
        );
      }
    },
    getServiceDescription() {
      if (this.sd) {
        this.serviceDescription = this.sd;
      } else {
        let that = this;
        var ref = firebase.database().ref("/productInfo");
        ref.on(
          "value",
          function(snapshot) {
            that.serviceDescription = snapshot.val().serviceDescription;
            // console.log(that.serviceDescription);
          },
          function(error) {
            // console.log("Error: " + error.code);
          }
        );
      }
    }
  },
  mounted() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    this.getServices();
    this.getServiceDescription();
  }
};
</script>
<style scoped>
.img-car {
  padding-top: 100px;
  padding-left: 300px;
  padding-right: 300px;
  width: 100%;
}
</style>